var CONFUSEDCMS = CONFUSEDCMS || {};

// Use 3rd party Yall library to set up lazy loading of images
(function (yall) {
	CONFUSEDCMS.setupLazyLoading = function () {
		yall({
			observeChanges: true
		});
	};
})(window.yall);